// extracted by mini-css-extract-plugin
module.exports = {"container":"_1g9lFo5zmr5LuZ5MCQaco0"};